module.exports = __webpack_public_path__ + "img/companyIntro15.7d35f8df.png";